<section class="a_denied">
  <!-- Image -->
  <img class="ad_icon" src="assets/images/page-not-found.svg" />

  <!-- Title -->
  <h3 class="sub_title_2 fw_700 text_dark_blue lh_36 mb-2">Oops! Page Not Fond</h3>

  <!-- Caption -->
  <p class="lh_22 mb-4 text_center text_grey">
    The page doesn't exist or was removed!

    <br />
    We suggest you back to home.
  </p>

  <!-- Back To Home -->
  <a href="" class="btn btn_primary" routerLink="/">Back to Home</a>
</section>
